import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';

class ResourcesHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resources: [],
      filterType: ''
    };
  }

  render() {
    return (
      <div className={'row'}>
        <h3>Training Resources</h3>
        <div className="row">
          <div className="column large-4 callout">
            <Link
              className={'button float-right'}
              to={'/all-training-resources'}
            >
              <i className="fas fa-list"> </i> View published training resources{' '}
            </Link>
          </div>
          <div className="column large-4 callout">
            <Link className={'button float-right'} to={'#'}>
              <i className="fas fa-list"> </i> View unpublished training
              resources{' '}
            </Link>
          </div>
          <div className={'column large-4 callout'}>
            <Link className={'button float-right'} to={'#'}>
              <i className="fas fa-tasks"> </i> Manage training resources{' '}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const ResourcesHomepage = () => (
  <Switch>
    <Route exact path="/training-resources-home" component={ResourcesHome} />
  </Switch>
);

export default ResourcesHomepage;
